import React, { useState } from 'react';

const ChatSettings = ({ settings, onSettingsChange, workspaces, graphs }) => {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <div className="chat-settings">
      <div 
        className="chat-settings-header"
        onClick={() => setCollapsed(!collapsed)}
      >
        <div className="chat-settings-title">
          <span>Pipeline Settings</span>
          {settings.graph_id && (
            <span style={{ fontWeight: 'normal', fontSize: '12px', color: '#666' }}>
              (Graph: {settings.graph_id.substring(0, 8)}...)
            </span>
          )}
        </div>
        <span className="chat-settings-toggle">
          {collapsed ? '▼ Expand' : '▲ Collapse'}
        </span>
      </div>

      <div className={`chat-settings-body ${collapsed ? 'collapsed' : ''}`}>
        {/* Execution Mode */}
        <div className="settings-group">
          <label htmlFor="execution_mode">Execution Mode</label>
          <select
            id="execution_mode"
            value={settings.execution_mode}
            onChange={(e) => onSettingsChange('execution_mode', e.target.value)}
          >
            <option value="BUILD_AND_RUN">BUILD_AND_RUN</option>
            <option value="BUILD_ONLY">BUILD_ONLY</option>
          </select>
        </div>

        {/* Workspace ID */}
        <div className="settings-group">
          <label htmlFor="workspace_id">Workspace ID</label>
          <select
            id="workspace_id"
            value={settings.workspace_id}
            onChange={(e) => onSettingsChange('workspace_id', e.target.value)}
          >
            <option value="">-- Select Workspace --</option>
            {workspaces.map(ws => (
              <option key={ws.WorkspaceId || ws.id} value={ws.WorkspaceId || ws.id}>
                {ws.Name || ws.name || ws.WorkspaceId || ws.id}
              </option>
            ))}
          </select>
          <input
            type="text"
            placeholder="Or enter workspace ID manually"
            value={settings.workspace_id}
            onChange={(e) => onSettingsChange('workspace_id', e.target.value)}
            style={{ marginTop: '4px' }}
          />
        </div>

        {/* Graph ID */}
        <div className="settings-group">
          <label htmlFor="graph_id">Graph ID</label>
          <select
            id="graph_id"
            value={settings.graph_id}
            onChange={(e) => onSettingsChange('graph_id', e.target.value)}
          >
            <option value="">-- Select Graph --</option>
            {graphs.map(g => (
              <option key={g.GraphId || g.id} value={g.GraphId || g.id}>
                {g.Name || g.name || g.GraphId || g.id}
              </option>
            ))}
          </select>
          <input
            type="text"
            placeholder="Or enter graph ID manually"
            value={settings.graph_id}
            onChange={(e) => onSettingsChange('graph_id', e.target.value)}
            style={{ marginTop: '4px' }}
          />
        </div>

        {/* Min Similarity */}
        <div className="settings-group">
          <label htmlFor="min_similarity">Min Similarity</label>
          <input
            id="min_similarity"
            type="number"
            min="0"
            max="1"
            step="0.1"
            value={settings.min_similarity}
            onChange={(e) => onSettingsChange('min_similarity', parseFloat(e.target.value) || 0)}
          />
        </div>

        {/* Engine Mode */}
        <div className="settings-group">
          <label htmlFor="engine_mode">Engine Mode</label>
          <select
            id="snn_execution_mode"
            value={settings.snn_execution_mode}
            onChange={(e) => onSettingsChange('snn_execution_mode', e.target.value)}
          >
            <option value="compiled_sharded">compiled_sharded</option>
            <option value="compiled_full">compiled_full</option>
            <option value="not_compiled">not_compiled</option>
          </select>
        </div>

        {/* Similarity Top K */}
        <div className="settings-group">
          <label htmlFor="similarity_top_k">Similarity Top K</label>
          <input
            id="similarity_top_k"
            type="number"
            min="1"
            max="500"
            value={settings.similarity_top_k}
            onChange={(e) => onSettingsChange('similarity_top_k', parseInt(e.target.value) || 150)}
          />
        </div>

        {/* Decompose Query */}
        <div className="settings-group">
          <div className="settings-checkbox">
            <input
              id="decompose_query"
              type="checkbox"
              checked={settings.decompose_query}
              onChange={(e) => onSettingsChange('decompose_query', e.target.checked)}
            />
            <label htmlFor="decompose_query">Decompose Query</label>
          </div>
        </div>

        {/* NL Prompt */}
        <div className="settings-group full-width">
          <label htmlFor="nl_prompt">NL Prompt (optional context for LLM)</label>
          <textarea
            id="nl_prompt"
            value={settings.nl_prompt}
            onChange={(e) => onSettingsChange('nl_prompt', e.target.value)}
            placeholder="Optional natural language prompt to provide additional context for the LLM response generation..."
          />
        </div>
      </div>
    </div>
  );
};

export default ChatSettings;
